module.exports = __webpack_public_path__ + "img/5-1.dae52d6b.svg";